// import { NavLink } from "react-router-dom";
import JobZImage from "../../../common/jobz-img";
// import SectionRecordsFilter from "../../public-user/sections/common/section-records-filter";
// import SectionPagination from "../../public-user/sections/common/section-pagination";
import { useEffect, useState } from "react";
import { loadScript } from "../../../../globals/constants";
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { Helmet } from 'react-helmet-async';
import { useTranslation } from "react-i18next";

const getColorClass = (char) => {
    if (!char) return "bg-default";
    const letter = char.toUpperCase();
    const colors = {
        A: "bg-red", B: "bg-blue", C: "bg-green", D: "bg-orange", E: "bg-purple",
        F: "bg-teal", G: "bg-pink", H: "bg-indigo", I: "bg-yellow", J: "bg-cyan",
        K: "bg-lime", L: "bg-rose", M: "bg-amber", N: "bg-violet", O: "bg-emerald",
        P: "bg-fuchsia", Q: "bg-sky", R: "bg-gray", S: "bg-zinc", T: "bg-stone",
        U: "bg-neutral", V: "bg-blue-500", W: "bg-orange-600", X: "bg-indigo-500",
        Y: "bg-pink-600", Z: "bg-teal-600",
    };
    return colors[letter] || "bg-default";
};

function CanMyJobLoopPage() {
    const { t } = useTranslation();
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    // const [filterConfig, setFilterConfig] = useState({
    //     prefix: "Applied",
    //     type: "jobs",
    //     total: "0",
    //     showRange: false,
    //     showingUpto: ""
    // });

    useEffect(() => {
        loadScript("js/custom.js");

        const fetchAppliedJobs = async () => {
            try {
                const response = await axiosInstance.get(`${API_URL}/getAllJobLoop`);
                if (response.data.status === 200) {
                    setAppliedJobs(response.data.data);
                    // setFilterConfig(prev => ({
                    //     ...prev,
                    //     total: response.data.total.toString()
                    // }));
                }
                console.log("JOB", response);
            } catch (err) {
                console.error("Error fetching applied jobs", err);
            } finally {
                setDataLoaded(true);
            }
        };

        fetchAppliedJobs();
    }, []);

    const filteredJobs = appliedJobs.filter((job) =>
        `${job.title} ${job.title}`.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (

        <>
            <Helmet>
                <title>My loops | Job Contact</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="twm-right-section-panel candidate-save-job site-bg-gray">
                {/* <SectionRecordsFilter _config={filterConfig} /> */}

                <div className="mb-4">
                    <label>{t("Search Job")}</label>
                    <input
                        type="text"
                        placeholder={`${t("Search")}...`}
                        className="form-control"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} />
                </div>

                <div className="twm-jobs-list-wrap">
                    {dataLoaded ? (
                        <ul>
                            {filteredJobs.length > 0 ? (
                                filteredJobs.map((job, index) => (
                                    <li key={index}>
                                        <div className="twm-jobs-list-style1 mb-5">
                                            <div className="twm-media">
                                                {job.companyLogo ? (
                                                    <JobZImage src={job.companyLogo} alt={job.title} />
                                                ) : (
                                                    <div className={`company-logo-placeholder ${getColorClass(job.title?.charAt(0))}`}>
                                                        {job.title?.charAt(0)?.toUpperCase() || ''}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="twm-mid-content">
                                                {/* <NavLink to={`${job.job_url}/${job.id}`} target="_blank" className="twm-job-title"> */}
                                                <h4 className="twm-job-title">
                                                    {job.title}{" "}
                                                    <span className="twm-job-post-duration">
                                                        / {job.experience.replace("_", " ").replace(/\b\w/g, c => c.toUpperCase())}
                                                    </span>
                                                </h4>
                                                {/* </NavLink> */}
                                                <p className="twm-job-address">{job.location}</p>
                                                <a href={job.companyWebsite} className="twm-job-websites site-text-primary">
                                                    {job.companyWebsite}
                                                </a>
                                                <p>{t("Applied Job")} : {job.total_applied_jobs}</p>
                                            </div>
                                            <div className="twm-right-content">
                                                <div className="twm-jobs-category">
                                                    <span
                                                        className={`${job.job_type === 'Full time'
                                                            ? 'twm-bg-purple'
                                                            : job.job_type === 'Contract'
                                                                ? 'twm-bg-sky'
                                                                : job.job_type === 'Part time'
                                                                    ? 'twm-bg-golden'
                                                                    : job.job_type === 'Internship'
                                                                        ? 'twm-bg-green'
                                                                        : job.job_type === 'Temporary'
                                                                            ? 'twm-bg-brown'
                                                                            : ''}`}
                                                    >
                                                        {job.job_type}
                                                    </span>
                                                </div>
                                                <div className="twm-jobs-amount">
                                                    <span>{job.status.toUpperCase()}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))
                            ) : (
                                <p>{t("No jobs found.")}</p>
                            )}
                        </ul>
                    ) : (
                        <p>{t("Loading jobs")}...</p>
                    )}
                </div>
                {/* <SectionPagination /> */}
            </div>
        </>
    );
}

export default CanMyJobLoopPage;
